/* global $ */

const $element = $('.calculator-modal');

const calculatorModal = {
  initialize() {
    if (!$element.length) {
      return;
    }

    $element.on('show.bs.modal', () => {
      $element.find('[data-src]').toArray().forEach((element) => {
        element.setAttribute('src', element.getAttribute('data-src'));
      });
    });
  },
};

export default calculatorModal;
